<template>
  <div @click="makeActive" class="box" :class="active ? 'active' : null" :id="service.title.toLowerCase()">
    <div class="heading">
      <h1 class="title">{{ service.title }}</h1>
    </div>
    <div class="content">
      <p class="description">{{ service.description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'service',
  props: {
    service: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      msg: 'Studio 308 Service'
    }
  },
  methods: {
    makeActive () {
      this.$emit('activated')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Service.vue?ab53a87e